export type AssetStorageMode =
  | 'indexeddb-local-mvp'
  | 'cloud-r2-planned'
  | 'cloud-r2-ready';

export type AssetUploadStatus =
  | 'local-only'
  | 'pending-upload'
  | 'uploading'
  | 'uploaded'
  | 'failed'
  | 'not-configured';

export interface CloudAssetRef {
  provider: 'cloudflare-r2';
  bucket?: string;
  objectKey?: string;
  publicUrl?: string;
  signedUrlExpiresAt?: string;
  uploadedAt?: string;
  checksum?: string;
  sizeBytes?: number;
  mimeType?: string;
}

export interface AssetStorageCapabilities {
  canStoreOriginals: boolean;
  canRestoreAfterRefresh: boolean;
  canExportProductionPackage: boolean;
  requiresUserConsent: boolean;
  requiresBackend: boolean;
  notes: string[];
}

export interface AssetUploadPlan {
  projectId: string;
  storageMode: AssetStorageMode;
  expectedAssetCount: number;
  estimatedTotalBytes: number;
  acceptedMimeTypes: string[];
  maxSingleFileBytes: number;
  maxProjectBytes: number;
  targetProvider: 'cloudflare-r2';
  requiredEndpoints: string[];
}

export const localAssetStorageMode = 'indexeddb-local-mvp' as const;
